var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGolfGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offer Icon / golf_gray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707784",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E535C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offer-Icon-/-golf_gray",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1796875,18 C19.921875,16.2750092 21.75,13.2281342 21.75,9.75 C21.75,4.36404419 17.3859558,0 12,0 C6.61404419,0 2.25,4.36404419 2.25,9.75 C2.25,13.2281342 4.078125,16.2750092 6.8203125,18 L17.1796875,18 Z M13.3078308,11.8078308 C12.6328125,11.8078308 12.0749817,11.3718567 11.859375,10.7718658 C13.0921783,11.2125092 14.2734375,10.0640717 13.8234558,8.80783081 C14.4234467,9.0234375 14.859375,9.58126831 14.859375,10.2562408 C14.859375,11.1140442 14.1656342,11.8078308 13.3078308,11.8078308 Z M17.0578308,12.5578308 C16.3828125,12.5578308 15.8249817,12.1218567 15.609375,11.5218658 C16.8421783,11.9625092 18.0234375,10.8140717 17.5734558,9.55783081 C18.1734467,9.7734375 18.609375,10.3312683 18.609375,11.0062408 C18.609375,11.859375 17.9156342,12.5578308 17.0578308,12.5578308 Z M14.0578308,15.5578308 C13.3828125,15.5578308 12.8249817,15.1218567 12.609375,14.5218658 C13.8421783,14.9625092 15.0234375,13.8140717 14.5734558,12.5578308 C15.1734467,12.7734375 15.609375,13.3312683 15.609375,14.0062408 C15.609375,14.859375 14.9156342,15.5578308 14.0578308,15.5578308 Z M12.9375,24 C13.2468567,24 13.5,23.7468567 13.5,23.4375 L13.5,22.5 C13.5,21.6703033 14.1703033,21 15,21 L15.75,21 C16.5796967,21 17.25,20.3296967 17.25,19.5 L6.75,19.5 C6.75,20.3296967 7.42030334,21 8.25,21 L9,21 C9.82969666,21 10.5,21.6703033 10.5,22.5 L10.5,23.4375 C10.5,23.7468567 10.7531433,24 11.0625,24 L12.9375,24 Z",
    id: "icon",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfGray);
export default __webpack_public_path__ + "static/media/golf_gray.88aaa8d038cf9ba97ac0981ff4f4e8cd.svg";
export { ForwardRef as ReactComponent };